import { StyleSheet } from "react-native";
import { appColors, appFonts, fontSize } from "../../../appTheme";

export const modifierSetStyle = StyleSheet.create({
    outerView: {
        flex: 1,
        backgroundColor: appColors?.lightBackgroundColor
    },
    modalOuterView: {
        flex: 1,
        backgroundColor: appColors?.transparentBackground,
        justifyContent: "center",
        alignItems: "center"
    },
    innerView: {
        backgroundColor: appColors?.light,
        borderRadius: 10,
        overflow: "hidden",
    },
    modelHeader: {
        width: "100%",
        padding: 15,
        backgroundColor: appColors?.lightBackgroundColor,
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        paddingTop: 10,
        paddingHorizontal: 15
    },
    contentView: {
        paddingTop: 20,
        paddingBottom: 10,
        paddingHorizontal: 20,
    },
    inputStyle: {
        fontSize: fontSize?.smallerFontSize,
        color: appColors?.dark,
        top: -3,
        fontFamily: appFonts?.medium
    },
    dropDownListView: {
        flex: 1,
        flexDirection: 'row',
        padding: 10,
        alignItems: "center"
    },
    dropdownStyle: {
        borderWidth: 0.3,
        borderRadius: 5,
        borderColor: appColors?.grey
    },
    dropDownContainerStyle: {
        borderWidth: 0.3,
        borderColor: appColors?.grey,
        position: "relative", top: 0
    },
    searchContainerStyle: {
        borderBottomWidth: 0.3,
        borderColor: appColors?.grey
    },
    dropdownErrorStyle: {
        paddingVertical: 10,
        paddingLeft: 18,
        paddingTop: 10
    },
    buttonOuterView: {
        padding: 10,
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "flex-end",
        paddingHorizontal: 20,
        borderTopWidth: 0.34,
        borderTopColor: appColors?.lightGrey,
    },
    buttonStyle: {
        backgroundColor: appColors?.light,
        borderRadius: 10,
        padding: 10,
        paddingHorizontal: 20,
        borderWidth: 0.5,
        borderColor: appColors?.primary
    },
    saveButtonStyle: {
        backgroundColor: appColors?.primary,
        borderRadius: 10,
        padding: 10,
        paddingHorizontal: 20,
    }
})